/* @flow */

import React, { Component } from 'react';
import { WorkbenchMediaQueries } from '../../constants/WorkbenchBreakpoints';
import WorkbenchIcon from '../WorkbenchIcon/WorkbenchIcon';
import WorkbenchIcons from '../WorkbenchIcon/WorkbenchIcons';

type $Props = {
  mq: string,
  isSearchByLocationActive: boolean,
  searchLocationString: string,
  searchNameString: string,
  inputFieldPlaceholder: string,
  submitLabel: string,
  autoSuggestionEnabled: boolean,
  hoveredIndex: number,
  onSearchCriteriaLocationChange: Function,
  onSearchCriteriaNameChange: Function,
  onSearchFocus: Function,
  onSearchBlur: Function,
  handleKeyboardInput: Function
};

type $State = {
  isActive: boolean
};

export default class DealersSearchField extends Component<$Props, $State> {

  state = {
    isActive: false
  };

  refSearchInputField = null;

  handleInputFieldSearchFocusChange = (isActive: boolean) => {
    this.setState({ isActive }, () => {
      isActive ? this.props.onSearchFocus() : this.props.onSearchBlur();
    });
  };

  handleInputFieldSearchChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (this.props.isSearchByLocationActive) this.props.onSearchCriteriaLocationChange(value);
    else this.props.onSearchCriteriaNameChange(value);
  };

  handleKeyboardKeyPressed = (event: SyntheticInputEvent<HTMLInputElement>) => {
    const { autoSuggestionEnabled, hoveredIndex } = this.props;
    if(!autoSuggestionEnabled || (autoSuggestionEnabled && hoveredIndex >= 0)) {
      if(event.keyCode === 13 && this.refSearchInputField) this.refSearchInputField.blur();
      this.props.handleKeyboardInput(event);
    }
  };

  render() {
    const baseClassName = 'dl-dealers-search';
    const wrapperClassName = baseClassName + (this.state.isActive ? ` ${baseClassName}__active` : '');
    const value = this.props.isSearchByLocationActive ? this.props.searchLocationString : this.props.searchNameString;
    const submitLabelRenderMQs = [
      WorkbenchMediaQueries.MQ3,
      WorkbenchMediaQueries.MQ4,
      WorkbenchMediaQueries.MQ5,
      WorkbenchMediaQueries.MQ6
    ];

    return (
      <div className={ wrapperClassName }>
        <input
          type="text"
          className={ `${baseClassName}__field` }
          placeholder={ this.props.inputFieldPlaceholder }
          spellCheck={ false }
          onChange={ this.handleInputFieldSearchChange }
          onFocus={ () => this.handleInputFieldSearchFocusChange(true) }
          onBlur={ () => this.handleInputFieldSearchFocusChange(false) }
          onKeyDown={ this.handleKeyboardKeyPressed }
          ref={ (input => this.refSearchInputField = input) }
          value={ value }
        />
        { (!this.props.autoSuggestionEnabled || !this.props.isSearchByLocationActive) &&
          <button type="submit" className={`${baseClassName}__submit`}>
            <WorkbenchIcon icon={WorkbenchIcons.ICO_ARROW_4} modifierClass={`${baseClassName}__submit--ico`} />
            { this.props.submitLabel && this.props.mq && submitLabelRenderMQs.includes(this.props.mq.toUpperCase()) &&
              <span className={`${baseClassName}__submit--label`}>
                {this.props.submitLabel}
              </span>
            }
          </button>
        }
      </div>
    );
  }
}
